"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');

var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _actionCreators = require('shared/actions/actionCreators'); var _actionCreators2 = _interopRequireDefault(_actionCreators);
var _useBus = require('shared/hooks/useBus'); var _useBus2 = _interopRequireDefault(_useBus);



 const ACCOUNT_ROLE_LABELS = { owner: 'Owner', it: 'IT' }; exports.ACCOUNT_ROLE_LABELS = ACCOUNT_ROLE_LABELS

 const ORG_ROLE_LABELS = { admin: 'Admin', user: 'User' } ; exports.ORG_ROLE_LABELS = ORG_ROLE_LABELS

// D-38, D-39: IT adds organizations and sees the plan; only Owners cancel it
// and make Owners.
 const ACCOUNT_ROLE_HINTS = {
  it: 'Every organization\'s people and settings, adding organizations, the plan, and the account\'s API keys and integrations.',
  owner: 'Everything IT can do, plus cancelling the plan and making other Owners.',
}; exports.ACCOUNT_ROLE_HINTS = ACCOUNT_ROLE_HINTS

// D-38: shown whenever someone is about to be made IT or Owner.
 const ACCOUNT_ROLE_WARNING = 'By adding this person as IT or Owner, they get access to all of the organizations on your account.'; exports.ACCOUNT_ROLE_WARNING = ACCOUNT_ROLE_WARNING

// E-37: the Remove dialog when removing someone deletes their user.
 const REMOVE_AND_DELETE_USER_LABEL = 'Remove and delete user'; exports.REMOVE_AND_DELETE_USER_LABEL = REMOVE_AND_DELETE_USER_LABEL
 const deleteUserNotice = (orgName) =>
  `${orgName} is their only organization, so this deletes their BloomText user. They won't be able to sign in. This can't be undone.`; exports.deleteUserNotice = deleteUserNotice

// RemoveUserFromOrg refuses a removal that would delete the user unless it
// confirms it (D-60): the dialog then asks again with the delete copy.
 const isConfirmDeleteUserError = (e) =>
  String(_nullishCoalesce(_optionalChain([(e ), 'optionalAccess', _ => _.Error]), () => ( ''))).startsWith('confirmation_required'); exports.isConfirmDeleteUserError = isConfirmDeleteUserError

// Why a person can't be removed from the account, or null when they can
// (D-125): an Owner's or IT person's role comes off first, and a membership
// an API key manages is that key's to remove.
 const removeFromAccountBlocker = (
  p


,
  orgName,
) => {
  if (p.AccountRole) return `Remove their ${exports.ACCOUNT_ROLE_LABELS[p.AccountRole]} role first.`
  // An automatic Owner/IT membership left without a role (F-38): the server
  // refuses it until the account's sync removes it.
  const automatic = p.Memberships.find(m => m.AccountManaged)
  if (automatic) return `Their membership in ${orgName(automatic.OrgKey)} is set on the Account page. Try again in a moment.`
  const byAPI = p.Memberships.find(m => m.ManagedBy === 'api')
  if (byAPI) return `${exports.apiManagerLabel.call(void 0, byAPI)} manages their membership in ${orgName(byAPI.OrgKey)}. Remove them with that key.`
  return null
}; exports.removeFromAccountBlocker = removeFromAccountBlocker

// The account roles a caller may give (D-38): Owners make Owners and IT,
// IT makes IT, everyone else neither.
 const grantableAccountRoles = (myRole) => {
  if (myRole === 'owner') return ['it', 'owner']
  if (myRole === 'it') return ['it']
  return []
}; exports.grantableAccountRoles = grantableAccountRoles

// An API key's membership (D-35), by the key's name when it has one.
 const apiManagerLabel = (m) =>
  m.ManagedByName ? `API: ${m.ManagedByName}` : 'API'; exports.apiManagerLabel = apiManagerLabel

// Why a member can't be managed or removed from an org's member list, or
// null when they can: Owners and IT are set on the Account page (D-34), and
// an API key's members are its own (D-35).
// The member is an Owner or IT person, or has their automatic membership:
// they're managed on the Account page, not here.
 const isSetOnAccountPage = (lock) => !!lock && (!!lock.AccountRole || !!lock.AccountManaged); exports.isSetOnAccountPage = isSetOnAccountPage

 const memberLockLabel = (lock) => {
  if (!lock) return null
  if (lock.AccountRole || lock.AccountManaged) return 'Set on the Account page'
  if (lock.ManagedBy === 'api') return `Managed by ${exports.apiManagerLabel.call(void 0, lock)}`
  return null
}; exports.memberLockLabel = memberLockLabel

 const ROLE_CHANGES = [
  _actionCreators2.default.grantAccountRoleActions.SUCCESS.type,
  _actionCreators2.default.revokeAccountRoleActions.SUCCESS.type,
]; exports.ROLE_CHANGES = ROLE_CHANGES

// Account → People's list changes: a role, or someone removed (D-125).
 const PEOPLE_CHANGES = [
  ...exports.ROLE_CHANGES,
  _actionCreators2.default.removeFromAccountActions.SUCCESS.type,
]; exports.PEOPLE_CHANGES = PEOPLE_CHANGES

const ACCOUNT_CHANGES = [
  ...exports.ROLE_CHANGES,
  _actionCreators2.default.saveAccountSettingsActions.SUCCESS.type,
  _actionCreators2.default.createAccountOrgActions.SUCCESS.type,
]

// undefined while loading; null when the account isn't flagged or failed to
// load, so the org shows today's pages.


// An Owner or IT person of a flagged account manages it, and is an admin of
// each of its orgs, as the server treats them.
 const isManagedAccount = (a) => !!_optionalChain([a, 'optionalAccess', _2 => _2.Flagged]) && !!a.MyRole; exports.isManagedAccount = isManagedAccount

// Where an org's sign-in security and patient privacy live: 'account' once
// its flagged account's settings are set up (D-91), else 'org' as today;
// null while that is still loading. Everyone in a flagged account learns it
// from GetAccount, so Admins' org pages also hide the settings that moved.


 const useSecuritySettingsHome = (account) => {
  if (account === undefined) return null
  return _optionalChain([account, 'optionalAccess', _3 => _3.Flagged]) && account.SettingsConfigured ? 'account' : 'org'
}; exports.useSecuritySettingsHome = useSecuritySettingsHome

/* The org's account when it is flagged for Accounts (D-88). Refreshes after
 * an account role, the account's settings or its orgs change, keeping the
 * last answer meanwhile. */
 const useOrgAccount = (orgKey) => {
  const [loaded, setLoaded] = _react.useState(null)
  const [reloads, setReloads] = _react.useState.call(void 0, 0)
  _react.useEffect.call(void 0, () => {
    if (!orgKey) return
    let isCurrent = true
    _actions2.default.getAccount({ OrgKey: orgKey })
      .then(view => { if (isCurrent) setLoaded({ orgKey, account: _optionalChain([view, 'optionalAccess', _4 => _4.Flagged]) ? view : null }) })
      .catch(() => { if (isCurrent) setLoaded({ orgKey, account: null }) })
    return () => { isCurrent = false }
  }, [orgKey, reloads])
  const reload = _react.useCallback.call(void 0, () => setReloads(n => n + 1), [])
  _useBus2.default.call(void 0, ACCOUNT_CHANGES, reload)
  return orgKey && _optionalChain([loaded, 'optionalAccess', _5 => _5.orgKey]) === orgKey ? loaded.account : undefined
}; exports.useOrgAccount = useOrgAccount
